import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { VentaInscripcionComponent } from './formulario/formulario.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'servicio-financiero/inscripcion',
    children: [
       { path: 'lista', component: ListaComponent},
       { path: 'nuevo', component: VentaInscripcionComponent },
       { path: 'editar/:id', component: VentaInscripcionComponent},
    ],
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class InscripcionRoutingModule { }

